import EventBus from '_lib/EventBus';

const Friends = {
  state: {
    entry_can_operations: {}, // 消息入口权限映射表
    temp_recent_msgs: [], // 临时添加的最近消息id列表
  },
  getters: {
    entry_can_operations: (state) => state.entry_can_operations,
    temp_recent_msgs: (state) => state.temp_recent_msgs,
  },
  mutations: {
    SET_ENTRY_CAN_OPERATIONS(state, val) {
      state.entry_can_operations = val;
    },
    SET_TEMP_RECENT_MSGS(state, val) {
      state.temp_recent_msgs = val;
    },
  },
};

export default Friends;
